import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@material-ui/core';

import { formatMoney } from 'src/utils/common';
import { useStyles } from './styles';
import { formatFinalValue } from '../utils';

function Header({ data }) {
  const { type, nome, valor, cupom, parcela, valorParcela } = data;

  const classes = useStyles();

  const tratedValor = type === 'SERVICO' ? valor : parseFloat(valor / 100);
  const valorFinal = formatMoney(tratedValor);

  console.log(type);

  return (
    <>
      <Card className={classes.marginBottom}>
        <CardContent>
          <div className={classes.viewRow}>
            <Typography className={classes.textContent}>{nome}</Typography>
          </div>
        </CardContent>
      </Card>
      <Card className={classes.marginBottom}>
        <CardContent>
          <div className={classes.viewColumn}>
            <div>
              <Typography className={classes.label}>Valor</Typography>
              <Typography className={classes.textContent}>
                {valorFinal}
              </Typography>
              {cupom && (
                <>
                  <Typography
                    className={`${classes.label} ${classes.marginTop}`}
                  >
                    Valor final com desconto
                  </Typography>
                  <Typography className={classes.textContent}>
                    {formatFinalValue(tratedValor, cupom)}
                  </Typography>
                </>
              )}
            </div>
            <div>
              {parcela !== 1 ? (
                <div>
                  <Typography>Parcelas:</Typography>
                  <Typography className={classes.onlyMarginLeft}>
                    {`${parcela}x de R$ ${valorParcela}`}
                  </Typography>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}

Header.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string,
    nome: PropTypes.string,
    valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    parcela: PropTypes.number,
    valorParcela: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    cupom: PropTypes.shape({
      cupom: PropTypes.string,
      valor: PropTypes.number,
    }),
  }),
};

export default Header;
